import { useMutation } from "@tanstack/react-query";

import { MutationKeys } from "constants/mutation-keys";
import { ApiManager } from "services/api";
import { IUpdateIntroFlagsPayload } from "services/api/knowledgebase/knowledgebase-api";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useUpdateKnowledgebaseIntroFlags = () => {
  return useMutation({
    mutationKey: [MutationKeys.KnowledgeBaseIntroFlags],
    mutationFn: async (payload: IUpdateIntroFlagsPayload) => {
      const { error } = await ApiManager.knowledgebaseApi.updateIntroFlags(payload);

      return error;
    },
  });
};
